// useEditUser.ts

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editUser as editUserApi } from '../services/apiUsers.ts';
import { toast } from '../utils/sweetAlert.ts';

export function useEditUser() {
  const queryClient = useQueryClient();

  const { isLoading: isEditingUser, mutate: editUser } = useMutation({
    mutationFn: (updatedUser: { firstName: string; lastName: string; userId: string; roles: string[] }) =>
      editUserApi(updatedUser.firstName, updatedUser.lastName, updatedUser.userId, updatedUser.roles),
    onSuccess: () => {
      queryClient.invalidateQueries(['users']);
      toast('success', 'User updated successfully!');
    },
    onError: (error: any) => {
      toast('error', `Something went wrong! ${error.message}`);
    },
  });

  return { isEditingUser, editUser };
}

